import { DeleteModal } from 'components/common/DeleteModal';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSearch, getSearches } from 'redux/searchesSlice';
import AlertItem from './AlertItem';

const AlertList = ({ callToast, isLoading, setIsLoading }) => {
  // * States
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { searches } = useSelector(state => state.searches);
  const dispatch = useDispatch();
  const userLogged = useSelector(state => state.login.currentUser);

  // * Methods
  const FetchData = async () => {
    setIsLoading(true);
    await dispatch(getSearches(userLogged.id));
    setIsLoading(false);
  };

  const DeleteItem = async id => {
    const res = await dispatch(deleteSearch({ id }));
    if (res.status < 300) {
      FetchData();
      callToast(
        '¡Alerta eliminada!',
        'La alerta fue eliminada correctamente.',
        'Justo ahora'
      );
    } else
      callToast(
        'Algo salió mal...',
        'La alerta no pudo ser eliminada. Inténtelo de nuevo.',
        'Justo ahora'
      );
  };

  return (
    <>
      {!isLoading &&
        searches.result.map(search => (
          <div key={search.id}>
            <AlertItem
              data={search}
              handleDelete={() => setOpenDeleteModal(search)}
            />
          </div>
        ))}
      <DeleteModal
        openDeleteModal={!!openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        element={openDeleteModal.name}
        setDeleting={() => DeleteItem(openDeleteModal.id)}
      />
    </>
  );
};

AlertList.propTypes = {
  callToast: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setIsLoading: PropTypes.func.isRequired
};

export default AlertList;
